import { PlansSection, PropertyDataSection } from "./components";

import './index.css'

interface TabsPropertyDataPersonalEffectsProps {
  id: number;
  duplicateId?: number
}

export const TabsPropertyDataPersonalEffects = ({ id, duplicateId }: TabsPropertyDataPersonalEffectsProps) => {
  return (
    <>
      <div className='mt-1'>
        <PlansSection id={id} duplicateId={duplicateId} />

        <PropertyDataSection id={id} duplicateId={duplicateId} />
      </div>
    </>
  );
}
